import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UseCases } from "@planzone/core";
import { task } from "@planzone/dto";
import { useModal } from "@root/client/modal";

import { Breadcrumbs } from "../breadcrumbs";
import { CreationDate } from "../date";
import { Props } from "./types";
import styles from "./styles.scss";

function DelayedTask({ notification, close }: Props) {
  const { pushView } = useModal();
  const { t } = useTranslation();
  const push = useNavigate();

  return (
    <div className={styles.notification}>
      <div className={styles.header}>
        <Breadcrumbs
          breadcrumbs={[
            {
              name: notification.data.zoneName,
              click: () => push(`/zones/${notification.data.zoneId}`),
            },
            {
              name: notification.data.projectName,
              click: () => {
                push(`/projects/${notification.data.projectId}`);
                close && close();
              },
            },
            {
              name: notification.data.taskName,
              click: () => {
                pushView({
                  key: UseCases.retrieveTask,
                  data: {
                    task: {
                      ...task,
                      uuid: notification.data.taskId,
                      name: notification.data.taskName,
                    },
                    isMultiProject: true,
                  },
                });
                close && close();
              },
            },
          ]}
        />
        <CreationDate date={notification.createdDate} />
      </div>
      <div className={styles.main}>
        <p className={styles.text}>
          {t("notifications.delayedTask.task")}{" "}
          <span
            className={styles.task}
            onClick={() => {
              close && close();
              pushView({
                key: UseCases.retrieveTask,
                data: {
                  task: {
                    ...task,
                    uuid: notification.data.taskId,
                    name: notification.data.taskName,
                  },
                  isMultiProject: true,
                },
              });
            }}
          >
            {notification.data.taskName}
          </span>{" "}
          {t("notifications.delayedTask.is")}
          <span className={styles.delayed}>
            {" "}
            {t("notifications.delayedTask.delayed")}
          </span>
        </p>
      </div>
    </div>
  );
}

export { DelayedTask };
